export default __webpack_public_path__ + "static/BanImg1-3afb04419e74673f85201b2d205eb074.webp";